export const CUTOVER_DATE = '2026-09-14';

export function isCutoverReached(now: Date): boolean {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const localDate = `${year}-${month}-${day}`;

  return localDate >= CUTOVER_DATE;
}
